module.exports = __webpack_public_path__ + "static/screenshot2-9b0d10c927b8bd664d0c6575825016cc.png";